import { ref } from 'vue';

// Estado compartilhado (singleton no modulo) entre TimelineChat.vue e o
// CopilotLauncher.vue - gravando audio na caixa de nota do Historico,
// o Copilot flutuante precisa subir mais pra nao cobrir o botao de parar.
const isRecordingNoteAudio = ref(false);

export function useNoteComposerState() {
  return { isRecordingNoteAudio };
}
